import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import './styles.css';

const getCategoryRenderer = (searchFilter, isDisabledLegacyCommunity) => {
  const categoryRenderer = ({ name }) => {
    const lowerName = name.toLowerCase();
    const pathname = isDisabledLegacyCommunity ? `/counselorcommunity/search/${lowerName}` : `/search-results/${lowerName}`;
    return (
      <div>
        <h5 className="name">{name}</h5>
        <Link
          category-name={name}
          tabIndex={0}
          to={{ pathname, query: { keyword: searchFilter } }}
          styleName="more-link"
          onClick={() => setTimeout(() => window.dispatchEvent(new Event('counselor-community-serverless-update-route')), 0)}
        ><h5>More...</h5>
        </Link>
      </div>
    );
  };

  categoryRenderer.propTypes = {
    name: PropTypes.string,
  };
  return categoryRenderer;
};

export default getCategoryRenderer;
